
import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  BillDetailsList: (param) => {   // 支付管理-税单明细列表
    return GET('/merchant/taxBillRecord/queryByPage', param)
  },
  SystemJournal: (param) => {   // 系统日志-日志列表
    return GET('/merchant/systemLogInfo/queryByPage', param)
  },
  DailyRecordExport: (param, rsType) => {   // 系统日志-日志列表-导出
    return GETPDF('/merchant/systemLogInfo/merchantExport', param, rsType);
  },
  OperationLogDoc: (param) => {   // 操作日志-操作记录
    return GET('/merchant/operation/findOperationLogDoc', param);
  },
  exportExcelQuery: (param) => {   // 下载中心-下载记录
    return GET('/merchant/exportExcel/queryByPage', param);
  },
  findUrlExport: (param) => {   // 下载中心-下载
    return GET('/merchant/exportExcel/findUrlByExportExcelId', param);
  },
  deleteExport: (param) => {// 下载中心-删除
    return GET('/merchant/exportExcel/deleteExportExcelById', param)
  },
  // 个税计算器 正向计算器
  calTaxTrue: (param) => {
    return POST("/merchant/taxDetail/calTax/true", param);
  },

  // 个税计算器 反向向计算器
  calTaxFalse: (param) => {
    return POST("/merchant/taxDetail/calTax/false", param);
  },

  // 上传文件计算个税功能
  calTaxExcel: (param) => {
    return POST("/merchant/orderMain/calTaxExcel", param);
  },
  SystemSetting: (param) => { // 系统设置-系统设置列表
    return GET('/backend/dataDict/systemSetting', param);
  },

}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/receipt-regulate.js